import { Camera } from "../render/Camera";
import type { Demo, Scene } from "./types";
import { makeWorld, floor, walls, box, ball, nGon, trapezoid, rng } from "./helpers";

export const mixedPit: Demo = {
	id: "mixed-pit",
	title: "Mixed shapes pit",
	blurb:
		"Circles, boxes, triangles, pentagons, hexagons and trapezoids tumble into a bin — every contact pair at once: circle–circle, circle–polygon, and polygon–polygon.",
	category: "Stacking & Stress",
	build(): Scene {
		const world = makeWorld();
		floor(world, 18, 2);
		walls(world, 7, 16);

		const random = rng(1337);
		for (let i = 0; i < 70; i++) {
			const x = (random() - 0.5) * 11;
			const y = -2 - Math.floor(i / 7) * 1.3;
			const angle = random() * Math.PI;
			const opts = { angle, restitution: 0.1, friction: 0.5 };
			const pick = Math.floor(random() * 6);
			const r = 0.32 + random() * 0.3;
			switch (pick) {
				case 0:
					ball(world, x, y, r, { ...opts, restitution: 0.15 });
					break;
				case 1: {
					const s = 0.5 + random() * 0.5;
					box(world, x, y, s, s, opts);
					break;
				}
				case 2:
					nGon(world, x, y, 3, r + 0.15, opts); // triangle
					break;
				case 3:
					nGon(world, x, y, 5, r, opts); // pentagon
					break;
				case 4:
					nGon(world, x, y, 6, r, opts); // hexagon
					break;
				default:
					trapezoid(world, x, y, r * 2, r * 1.3, 0.4, opts);
					break;
			}
		}

		return { world, camera: new Camera(0, -3, 26) };
	},
};

